export default __webpack_public_path__ + "locales/it/Files.json?hash=efef67ab928c7950ce83864b73c01e6e";